// Source: MCS MIS 3002 zone Kk, EC JRC Climate-SAF-PVGIS × 0.8, 0° azimuth / 35° pitch.
//
// Plain CommonJS on purpose: this file is the single source of truth for both the
// React frontend (src/utils/SolarCalculations.jsx, src/components/OutputScreen.jsx,
// imported via webpack's CJS interop) and the Express backend
// (server/services/pdfService.js, via require()). It must live under src/ because
// CRA's ModuleScopePlugin forbids the frontend bundle from importing outside src/;
// Node has no equivalent restriction, so the backend reaching in here is fine.

const POSTCODE_TO_ZONE = {
  AB: '16', AL: '1',  B: '6',   BA: '5E', BB: '7E', BD: '11', BL: '7E', BN: '2',
  BR: '2',  BS: '5E', CA: '8E', CB: '12', CF: '5W', CH: '7E', CM: '12', CO: '12',
  CR: '1',  CT: '2',  CV: '6',  CW: '7E', DA: '2',  DD: '15', DE: '6',  DH: '10',
  DL: '10', DN: '11', DT: '3',  DY: '6',  E: '1',   EC: '1',  EH: '15', EN: '1',
  EX: '4',  FK: '14', FY: '7E', G: '14',  GL: '5E', GU: '1',  HA: '1',  HD: '11',
  HG: '10', HP: '1',  HR: '6',  HS: '18', HU: '11', HX: '11', IG: '12', IP: '12',
  IV: '17', KA: '14', KT: '1',  KW: '17', KY: '15', L: '7E',  LA: '7E', LD: '13',
  LE: '6',  LL: '7W', LN: '11', LS: '11', LU: '1',  M: '7E',  ME: '2',  MK: '1',
  ML: '14', N: '1',   NE: '9E', NG: '11', NN: '6',  NP: '5W', NR: '12', NW: '1',
  OL: '7E', OX: '1',  PA: '14', PE: '12', PH: '15', PL: '4',  PO: '3',  PR: '7E',
  RG: '1',  RH: '1',  RM: '12', S: '11',  SA: '5W', SE: '1',  SG: '1',  SK: '7E',
  SL: '1',  SM: '1',  SO: '3',  SP: '5E', SR: '9E', SS: '12', ST: '6',  SW: '1',
  SY: '6',  TN: '2',  TQ: '4',  TR: '4',  TS: '10', TW: '1',  UB: '1',  W: '1',
  WA: '7E', WC: '1',  WD: '1',  WF: '11', WN: '7E', WR: '6',  WS: '6',  WV: '6',
  YO: '10', ZE: '20',
};

const ZONE_KK = {
  '1': 980, '2': 1130, '3': 1021, '4': 1091, '5E': 971, '5W': 949, '6': 935,
  '7E': 865, '7W': 931, '8E': 877, '9E': 903, '10': 914, '11': 892, '12': 961,
  '13': 922, '14': 833, '15': 938, '16': 872, '17': 833, '18': 791, '20': 736,
  DEFAULT: 926,
};

const REAL_ZONE_VALUES = Object.entries(ZONE_KK)
  .filter(([key]) => key !== 'DEFAULT')
  .map(([, v]) => v);
const MIN_KK = Math.min(...REAL_ZONE_VALUES);
const MAX_KK = Math.max(...REAL_ZONE_VALUES);

function getPostcodeZone(postcode) {
  const prefix = (postcode || '').trim().toUpperCase().match(/^[A-Z]{1,2}/)?.[0] ?? '';
  return POSTCODE_TO_ZONE[prefix] ?? null;
}

function getZoneKk(postcode) {
  const zone = getPostcodeZone(postcode);
  return (zone && ZONE_KK[zone] !== undefined) ? ZONE_KK[zone] : ZONE_KK.DEFAULT;
}

// 0 at the UK's lowest-Kk zone, 1 at the highest. Drives both the viability score's
// irradiance component and the "Location" narrative tier thresholds, so they move
// together if this data is ever revised.
function getNormalizedIrradiance(postcode) {
  const kk = getZoneKk(postcode);
  return Math.min(1, Math.max(0, (kk - MIN_KK) / (MAX_KK - MIN_KK)));
}

module.exports = {
  POSTCODE_TO_ZONE,
  ZONE_KK,
  MIN_KK,
  MAX_KK,
  getPostcodeZone,
  getZoneKk,
  getNormalizedIrradiance,
};
